import React, { useState, useCallback, useEffect } from 'react';
import classnames from 'classnames';
import { ajax, apicRoot, wwwRoot, getQuery, cookieUtil } from '@liepin/js-core4c-fe';
import { message } from 'antd';
import styled from './index._less'
import emStyled from './em._less'
import compStyled from './comp._less'
import { throttle } from '../utils/throttle';

// import { SearchInputContainer } from './styled';
interface IProp {
  onClick?: (keyword?: string) => void,
}

const SearchInput: React.FC<IProp> = ({ onClick }: IProp) => {
  const [suggestList, setSuggestList] = useState([]);
  const [suggestComp4KeyWord, setSuggestComp4KeyWord] = useState({
    ecompLogo: '',
    ecompName: '',
    industryName: '',
    ecompStage: '',
    ecompScale: ''
  });
  const [isFocus, setIsFocus] = useState(false);
  const [searchVal, setSearchVal] = useState(getQuery('key') || '');
  
  const loadSuggestList = useCallback((val) => {
    if (val && val.length !== 0) {
      ajax({
        url: `${apicRoot}/api/com.liepin.searchfront4c.pc-search-suggest-list`,
        data: {
          keyword: val,
        }
      }).then(({ data }) => {
        setSuggestComp4KeyWord(data?.suggestComp4KeyWord);
        setSuggestList(data?.suggestWords || []);
      }).catch(({ message: msg }) => {
        setSuggestList([]);
        msg && message.info(msg);
      })
    } else {
      setSuggestList([]);
    }
  }, []);

  const throttleFn = throttle(loadSuggestList, 300);

  const handleChange = useCallback((e) => {
    const { value } = e.target;
    setSearchVal(value);
    throttleFn(value);
  }, []);
  
  const handleBlur = () => {
    setIsFocus(false)
    setTimeout(() => {
      setSuggestList([])
    }, 500)
  }

  const renderCom = useCallback(() => {
    if (!suggestComp4KeyWord) {
      return null;
    }
    const {
      ecompLogo,
      ecompName,
      industryName,
      ecompStage,
      ecompScale,
      ecompId,
    } = suggestComp4KeyWord;

    return (
      <a
        href={`${wwwRoot}/company/${ecompId}`}
        target='_blank'
      >
        <div className="comp-info" data-nick='job-card-compinfo' >
          <div className="logo-compName">
            <img src={`//image0.lietou-static.com/img/${ecompLogo}` } alt=""/>
            <span>{ecompName}</span>
          </div>
          {
            (industryName || ecompStage || ecompScale) && (
              <div className="comp-tags">
                {industryName && <label>{industryName}</label>}
                {ecompStage && <label>{ecompStage}</label>}
                {ecompScale && <label>{ecompScale}</label>}
              </div>
            )
          }
        </div>
        <style jsx>{compStyled}</style>
      </a>
    );
  }, [suggestComp4KeyWord]);

  // suggest列表
  const renderItem = useCallback(() => (
    <>
      <div className="suggest-list-inner">
        {
          renderCom()
        }
        {
          suggestList?.map((item, index) => (
            <span
              className="suggest-list-item"
              key={ index }
              onClick={ () => onClick?.(item) }
              dangerouslySetInnerHTML={{ __html: `${item.replace(searchVal.toLowerCase(), '<em class="em">' + searchVal.toLowerCase() + '</em>')}` }}
            />
          ))
        }
      </div>
      <style jsx>{emStyled}</style>
    </>
  ), [suggestList, searchVal]);

  return (
    <div className="search-input-container">
      <div className="search-input-box">
        <div className={classnames('search-input-inner', isFocus ? 'search-input-inner-active' : '')}>
          {/* 输入框 */}
          <div className="search-input">
            <input
              type="text"
              value={searchVal}
              placeholder="搜索职位/公司/内容关键词"
              onChange={handleChange}
              onFocus={ () => setIsFocus(true) }
              onBlur={ handleBlur }
              maxLength={ 100 }
              onKeyDown={ (e) => { e.keyCode === 13 && onClick?.(searchVal) } }
            />
            <span className="search-btn" onClick={() => onClick?.(searchVal)}>
              搜索
            </span>
          </div>
          {/* suggest */}
          {
            suggestList && suggestList.length !== 0 ? (
              <div className="suggest-list-box">
                {
                  renderItem()
                }
              </div>
            ) : null
          }
        </div>
      </div>
      {/* 热搜 */}
      
      <style jsx>{styled}</style>
    </div>
  );
}

export default SearchInput;
